import { Injectable } from "@angular/core";
import { Dialog, DialogRef } from "@angular/cdk/dialog";
import { map, Observable } from "rxjs";
import { ConfirmationModalComponent } from "../components/confirmation-modal/confirmation-modal.component";

/**
 * PURPOSE: responsible for presenting the confirmation dialog component
 */
@Injectable({
  providedIn: "root"
})
export class UnsavedChangesService {
  constructor(private dialog: Dialog) {}

  public showConfirmationDialog(): Observable<boolean> {
    const dialogRef: DialogRef<boolean> = this.dialog.open<boolean>(ConfirmationModalComponent, {
      width: "500px",
      disableClose: true,
      panelClass: "centered-dialog",
      data: {
        title: "Unsaved Changes",
        message:
          "If you navigate away from the page your unsaved changes will be lost. Do you want to continue editing or discard your unsaved changes?",
        confirmButtonText: "Discard Changes",
        cancelButtonText: "Continue Editing"
      }
    });

    return dialogRef.closed.pipe(map((showDialog: boolean | undefined): boolean => !!showDialog));
  }
}
